/* @format */
import store from '@/stores';
import { ClientService } from '@/scripts/services/entities/client-service';

/**
 * @param {import('vue-router').Route} to
 * @param {import('vue-router').Route} from
 * @param {function} next
 */
export async function activateSubscriptionGuard(to, from, next) {
    const redirectPath = from.path ?? '/';

    const clientId = store?.state?.context?.client?.id;
    if (!clientId) {
        return next(redirectPath);
    }

    const canNavigate = await ClientService.isClientLegacyAccess(clientId);

    if (!canNavigate) {
        return next(redirectPath);
    }

    next();
}
